export const PriceType = {
    NORMAL: "NORMAL",
    MULTIPLE: "MULTIPLA",
    MINIMUN: "MINIMA",
    TAKEMOREPAYLESS: "LEVEMAISPAGUEMENOS"
}
